import $api from "../http";

export default class OrdersService {
  static async changeOrder(merchantId, shopId, orderId, orderData) {
    return $api.put(
      `/Merchants/${merchantId}/shops/${shopId}/orders/${orderId}`,
      orderData,
    );
  }
}
